export const REGENERATE_EXPIRY_MONTHS = 3;

function parseServerDate(dt: string): Date {
  // "YYYY-MM-DD HH:mm:ss" → "YYYY-MM-DDTHH:mm:ss" (Safari 호환)
  const normalized = dt.includes('T') ? dt : dt.replace(' ', 'T');
  return new Date(normalized);
}

export function getRegenerateExpiryDate(paidDt: string): Date {
  const base = parseServerDate(paidDt);
  const expiry = new Date(base);
  expiry.setMonth(expiry.getMonth() + REGENERATE_EXPIRY_MONTHS);
  return expiry;
}

export function isRegenerateExpired(paidDt: string, now: Date = new Date()): boolean {
  return now.getTime() >= getRegenerateExpiryDate(paidDt).getTime();
}

export function getDaysUntilExpiry(paidDt: string, now: Date = new Date()): number {
  const expiry = getRegenerateExpiryDate(paidDt);
  const diffMs = expiry.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function formatExpiryDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
